import axios from 'axios'
import AuthenticationError from '../lib/errors/AuthenticationError'

const api = axios.create({
  baseURL: '', // will be set during param loading flow
  withCredentials: true
})

// default interceptors
api.interceptors.response.use((response) => {
  return response
}, (err) => {
  if (!err.response) {
    return Promise.reject(err)
  }

  if (err.response.status === 401) {
    // we save here the location href to redirect the user to the same page after login
    const originalLocation = window.location.href

    const callbackUrl = window.location.origin + '/login/callback'

    const renewUrl = `${api.defaults.baseURL}/sso/renew/token?location=${btoa(callbackUrl)}`

    // we check every 500ms if the login window is closed
    const timer = setInterval(() => {
      fetch(`${api.defaults.baseURL}/api/v1/auth/validate`, { method: 'POST', credentials: 'include' })
        .then(response => {
          if (response.status === 200) {
            // User is authenticated so we can close the popup
            clearInterval(timer)
            window.location = originalLocation
          }
        })
    }, 5000)

    return Promise.reject(new AuthenticationError('You will be redirect to the login page shortly.', renewUrl))
  }

  return Promise.reject(new Error(err.response.data.error.message))
})

export {
  api
}
